import PropTypes from "prop-types";
import styled from "styled-components";

function getBackground(props) {
    if (props.disabled) {
        return "rgba(112, 101, 93, 0.25) !important";
    }

    if (props.type === "submit") {
        return props.theme.primary;
    }

    return props.theme.tertiary;
}

function getCursor(props) {
    if (props.disabled) {
        return "not-allowed";
    }

    if (props.type === "text" || props.type === "password") {
        return "text";
    }

    return "pointer";
}

export const Input = styled.input`
    width: 100%;
    max-width: 280px;
    padding: 0.5em;
    border-radius: 0;
    appearance: none;
    background: ${props => getBackground(props)};

    color: ${props => (props.type === "submit" ? props.theme.tertiary : props.theme.secondary)};
    box-sizing: border-box;
    text-align: ${props => props.textAlign};
    display: block;
    font: inherit;
    font-size: 18px;
    border: ${props =>
        props.type === "password" || props.type === "text" ? "1px solid grey" : "none"};
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    cursor: ${props => getCursor(props)};
`;

Input.defaultProps = {
    disabled: false,
    textAlign: "left"
};

Input.propTypes = {
    disabled: PropTypes.bool,
    textAlign: PropTypes.string,
    type: PropTypes.string
};
